/**
 * QuickBooks Online — Connect / Reconnect landing page.
 *
 * This exact route (/qbo/connect) is registered with Intuit as this app's
 * "Launch URL" / Connect-Reconnect URL in the submitted app configuration —
 * it must exist at this path. It is intentionally thin: on mount it hands
 * off immediately to the backend, which owns the actual OAuth redirect to
 * Intuit (building the authorize URL, state, PKCE, etc). This page only
 * exists to give the browser somewhere to land before that redirect fires,
 * with a brief message in case there's any delay.
 *
 * Rendered OUTSIDE the ClickPay auth wall / app shell (see App.tsx) — Intuit
 * (and a signed-out browser mid-OAuth-handshake) may hit this route without
 * a ClickPay session.
 */
import { useEffect } from 'react'
import { Loader2 } from 'lucide-react'

export default function QboConnect() {
  useEffect(() => {
    window.location.href = '/api/ops/qbo/connect'
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm text-center">
        <div className="mx-auto w-12 h-12 rounded-xl bg-brand-600 text-white flex items-center justify-center mb-3 shadow-sm">
          <Loader2 size={22} className="animate-spin" aria-hidden />
        </div>
        <h1 className="text-xl font-semibold text-gray-900">ClickPay</h1>
        <p className="text-sm text-gray-600 mt-3">
          Connecting to QuickBooks&hellip;
        </p>
        <p className="text-xs text-gray-400 mt-2">
          If nothing happens in a few seconds,{' '}
          <a href="/api/ops/qbo/connect" className="text-brand-600 hover:underline">
            click here
          </a>.
        </p>
      </div>
    </div>
  )
}
